var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { action: "" } }, [
    _c("h2", { staticClass: "color__dark_blue" }, [
      _vm._v(_vm._s(_vm.get_translation_constant("calculator_block_title"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculator__block_header" }, [
      _c(
        "ul",
        {
          staticClass: "nav nav-tabs",
          attrs: { id: "calculatorTab", role: "tablist" },
        },
        [
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link active",
                attrs: {
                  "aria-controls": "weight",
                  "aria-selected": "true",
                  "data-bs-toggle": "tab",
                  href: "#weight",
                  id: "weight-tab",
                  role: "tab",
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.get_translation_constant("calculator_block_tab_weight")
                  )
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                attrs: {
                  "aria-controls": "product",
                  "aria-selected": "false",
                  "data-bs-toggle": "tab",
                  href: "javascript:void(0)",
                  id: "product-tab",
                  role: "tab",
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.get_translation_constant("calculator_block_tab_product")
                  )
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.expanded,
                  expression: "!expanded",
                },
              ],
              staticClass: "nav-item",
            },
            [
              _c(
                "a",
                {
                  staticClass: "nav-link with__arrow",
                  attrs: { href: _vm.ratesurl },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.get_translation_constant(
                        "calculator_block_tab_expand"
                      )
                    )
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "calculator__block_header_info" }, [
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.get_translation_constant("calculator_block_text_up_to_kg")
            ) + "\n                "
          ),
          _c("strong", [
            _vm._v(
              _vm._s(
                _vm.get_translation_constant(
                  "calculator_block_text_to_currency_kg"
                )
              )
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "tooltip__block tooltip__bottom" }, [
            _c("span", { staticClass: "tooltip__block_trigger" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M8 16c4.37 0 8-3.62 8-8 0-4.37-3.64-8-8-8-4.38 0-8 3.63-8 8 0 4.38 3.62 8 8 8Zm0-1.33A6.63 6.63 0 0 1 1.34 8 6.66 6.66 0 1 1 8 14.67ZM7.93 5.2c.57 0 1.02-.46 1.02-1.02 0-.57-.45-1.03-1.02-1.03-.57 0-1.02.46-1.02 1.03 0 .56.45 1.02 1.02 1.02Zm-1.31 7.1h3.2c.32 0 .57-.22.57-.55 0-.3-.25-.54-.57-.54h-.97v-4c0-.42-.22-.7-.61-.7H6.75a.55.55 0 0 0-.56.55c0 .32.25.55.56.55h.85v3.6h-.98a.55.55 0 0 0-.57.54c0 .33.26.55.57.55Z",
                      fill: "#000",
                    },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "tooltip__block_inner" }, [
              _c("pre", [_vm._v(_vm._s(_vm.deliverypricesummary))]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-content", attrs: { id: "calculatorTabContent" } },
        [
          _c(
            "div",
            {
              staticClass: "tab-pane fade show active",
              attrs: {
                "aria-labelledby": "weight-tab",
                id: "weight",
                role: "tabpanel",
              },
            },
            [
              _c("div", { staticClass: "form__col calculator__block_input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.weight,
                      expression: "weight",
                    },
                  ],
                  ref: "weight_calc_value",
                  staticClass: "form__control type_float",
                  attrs: { type: "number", autocomplete: "off" },
                  domProps: { value: _vm.weight },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.weight = $event.target.value
                      },
                      function ($event) {
                        return _vm.setSlide()
                      },
                    ],
                    change: function ($event) {
                      return _vm.setSlide()
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "weight_calc_value" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.get_translation_constant(
                        "calculator_block_text_weight_kg"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  ref: "weight_calc",
                  staticClass: "form__control",
                  attrs: { type: "text" },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "tooltip__block tooltip__bottom tooltip__modal",
                  },
                  [
                    _c("span", { staticClass: "tooltip__block_trigger" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 14 14",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                              fill: "#000000",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "tooltip__block_overlay" }, [
                      _c("span", { staticClass: "tooltip__block_inner" }, [
                        _c("pre", [_vm._v(_vm._s(_vm.deliverypricesummary))]),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              !_vm.expanded
                ? _c("div", { staticClass: "row justify-content-end" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 text-right total__price d-flex align-items-center justify-content-between justify-content-lg-end",
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.get_translation_constant(
                                "calculator_block_delivery_price"
                              )
                            ) +
                            "\n                        "
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.calculatedPriceByWeight)),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !!_vm.expanded
                ? _c("div", { staticClass: "size_calculator" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "checkbox__custom h_text_small with__line mb-3",
                      },
                      [
                        _c("span", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.calcBySize,
                                expression: "calcBySize",
                              },
                            ],
                            attrs: {
                              id: "size_calculator",
                              name: "size_calculator",
                              type: "checkbox",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.calcBySize)
                                ? _vm._i(_vm.calcBySize, null) > -1
                                : _vm.calcBySize,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.calcBySize,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.calcBySize = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.calcBySize = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.calcBySize = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "size_calculator" } }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.get_translation_constant(
                                    "calculator_block_text_weight_calculation"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "tooltip__block tooltip__bottom tooltip__modal",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "tooltip__block_trigger" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "14",
                                          height: "14",
                                          viewBox: "0 0 14 14",
                                          fill: "none",
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                                            fill: "#515154",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "tooltip__block_overlay" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "tooltip__block_inner" },
                                      [
                                        _c("span", {
                                          staticClass: "tooltip__block_close",
                                        }),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.get_translation_constant(
                                                "calculator_block_text_fill_all_sections"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form__col" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "row small-gutters justify-content-center justify-content-xl-between align-items-center flex-xl-nowrap",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-4 col-xl-auto pe-xl-0" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.dimensions.length,
                                    expression: "dimensions.length",
                                  },
                                ],
                                staticClass: "form__control w-160 type_float",
                                attrs: {
                                  type: "number",
                                  id: "length",
                                  name: "length",
                                  placeholder: _vm.get_translation_constant(
                                    "calculator_block_text_length_cents"
                                  ),
                                  disabled: _vm.isDisabled,
                                },
                                domProps: { value: _vm.dimensions.length },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.dimensions,
                                        "length",
                                        $event.target.value
                                      )
                                    },
                                    function ($event) {
                                      return _vm.checkDimensions()
                                    },
                                  ],
                                  change: function ($event) {
                                    return _vm.checkDimensions()
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-auto px-0 d-none d-xl-block" },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M7.1 17.34a.73.73 0 000 1.02c.28.27.74.27 1.02 0l4.66-4.66 4.66 4.66c.28.27.75.28 1.02 0a.74.74 0 000-1.02l-4.66-4.67 4.66-4.65a.73.73 0 000-1.03.74.74 0 00-1.02 0l-4.66 4.67-4.66-4.67a.73.73 0 00-1.03 0 .73.73 0 000 1.02l4.67 4.66-4.67 4.67z",
                                      fill: "#000",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-4 col-xl-auto px-xl-0" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.dimensions.height,
                                    expression: "dimensions.height",
                                  },
                                ],
                                staticClass: "form__control w-160 type_float",
                                attrs: {
                                  type: "number",
                                  id: "height",
                                  name: "height",
                                  placeholder: _vm.get_translation_constant(
                                    "calculator_block_text_height_cents"
                                  ),
                                  disabled: _vm.isDisabled,
                                },
                                domProps: { value: _vm.dimensions.height },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.dimensions,
                                        "height",
                                        $event.target.value
                                      )
                                    },
                                    function ($event) {
                                      return _vm.checkDimensions()
                                    },
                                  ],
                                  change: function ($event) {
                                    return _vm.checkDimensions()
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-auto px-0 d-none d-xl-block" },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M7.1 17.34a.73.73 0 000 1.02c.28.27.74.27 1.02 0l4.66-4.66 4.66 4.66c.28.27.75.28 1.02 0a.74.74 0 000-1.02l-4.66-4.67 4.66-4.65a.73.73 0 000-1.03.74.74 0 00-1.02 0l-4.66 4.67-4.66-4.67a.73.73 0 00-1.03 0 .73.73 0 000 1.02l4.67 4.66-4.67 4.67z",
                                      fill: "#000",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-4 col-xl-auto ps-xl-0" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.dimensions.width,
                                    expression: "dimensions.width",
                                  },
                                ],
                                staticClass: "form__control w-160 type_float",
                                attrs: {
                                  type: "number",
                                  id: "width",
                                  name: "width",
                                  placeholder: _vm.get_translation_constant(
                                    "calculator_block_text_width_cents"
                                  ),
                                  disabled: _vm.isDisabled,
                                },
                                domProps: { value: _vm.dimensions.width },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.dimensions,
                                        "width",
                                        $event.target.value
                                      )
                                    },
                                    function ($event) {
                                      return _vm.checkDimensions()
                                    },
                                  ],
                                  change: function ($event) {
                                    return _vm.checkDimensions()
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-auto h2 mb-0 mt-3 mt-xl-0" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.calcWeight.value)),
                              ]),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.calcWeight.unit) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !!_vm.expanded
                ? _c("div", { staticClass: "extra__services" }, [
                    _c("h4", { staticClass: "h_text_small with__line" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant(
                              "text_additional_services"
                            )
                          ) + " +"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _vm._l(
                          _vm.sliceIntoChunks(_vm.services, 3),
                          function (chunkServices, index) {
                            return _vm._l(
                              chunkServices,
                              function (service, chunk_index) {
                                return _c(
                                  "div",
                                  { staticClass: "col-12 col-md-6 col-xl-4" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "checkbox__custom" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.local_services[
                                                  index * 3 + chunk_index
                                                ].checked,
                                              expression:
                                                "local_services[index * 3 + chunk_index].checked",
                                            },
                                          ],
                                          attrs: {
                                            id:
                                              "checkbox" +
                                              (index * 3 + chunk_index),
                                            name:
                                              "checkbox" +
                                              (index * 3 + chunk_index),
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.local_services[
                                                index * 3 + chunk_index
                                              ].checked
                                            )
                                              ? _vm._i(
                                                  _vm.local_services[
                                                    index * 3 + chunk_index
                                                  ].checked,
                                                  null
                                                ) > -1
                                              : _vm.local_services[
                                                  index * 3 + chunk_index
                                                ].checked,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.local_services[
                                                    index * 3 + chunk_index
                                                  ].checked,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.local_services[
                                                        index * 3 + chunk_index
                                                      ],
                                                      "checked",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.local_services[
                                                        index * 3 + chunk_index
                                                      ],
                                                      "checked",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.local_services[
                                                    index * 3 + chunk_index
                                                  ],
                                                  "checked",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for:
                                                "checkbox" +
                                                (index * 3 + chunk_index),
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "tooltip__block tooltip__right tooltip__modal",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tooltip__block_trigger",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "service-image",
                                                      attrs: {
                                                        src: service.icon,
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._v(
                                                      "\n                                                  " +
                                                        _vm._s(service.title) +
                                                        "\n                                                "
                                                    ),
                                                    !!service.value
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _vm._v(
                                                              "+ " +
                                                                _vm._s(
                                                                  service.value
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                            service.as_a_percentage
                                                              ? [_vm._v("%")]
                                                              : [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getCurrencySymbol(
                                                                        service
                                                                      )
                                                                    )
                                                                  ),
                                                                ],
                                                          ],
                                                          2
                                                        )
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.get_translation_constant(
                                                                "text_free"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tooltip__block_overlay",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "tooltip__block_inner",
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "tooltip__block_close",
                                                        }),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              service.description
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href: service.link,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  service.link_info
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !!_vm.expanded
                ? _c("div", { class: _vm.calculatedWrapClass }, [
                    !!_vm.expanded && _vm.validated
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-6 col-lg-12 col-xl-6 mb-3 mb-xl-0",
                          },
                          [
                            _c("div", { staticClass: "info__alert" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.get_translation_constant(
                                      "calculator_block_text_fill_all_sections"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { class: _vm.calculatedClass }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.get_translation_constant(
                              "calculator_block_delivery_price"
                            )
                          ) +
                          "\n                        "
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.calculatedPriceByWeight))]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tab-pane fade",
              attrs: {
                "aria-labelledby": "product-tab",
                id: "product",
                role: "tabpanel",
              },
            },
            [
              _c("div", { staticClass: "mt-4 mb-4" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-4" }, [
                    _c(
                      "div",
                      { staticClass: "form__col" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant(
                                "text_product_category"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "multiselect",
                          {
                            attrs: {
                              multiple: false,
                              placeholder: _vm.get_translation_constant(
                                "text_choose_category"
                              ),
                              options: _vm.filteredCategories,
                              label: "name",
                              selectLabel: "",
                              deselectLabel: "",
                              optionHeight: 48,
                              showPointer: true,
                              id: "ajax",
                              "track-by": "name",
                              "open-direction": "bottom",
                              searchable: true,
                              loading: _vm.isLoading,
                              "internal-search": false,
                              "clear-on-select": true,
                              "close-on-select": true,
                              "options-limit": 300,
                              limit: 10,
                              "limit-text": _vm.limitText,
                              "max-height": 600,
                              "show-no-results": false,
                              "hide-selected": true,
                            },
                            on: { "search-change": _vm.asyncFind },
                            model: {
                              value: _vm.category,
                              callback: function ($$v) {
                                _vm.category = $$v
                              },
                              expression: "category",
                            },
                          },
                          [void 0],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-4" }, [
                    _c(
                      "div",
                      { staticClass: "form__col" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant(
                                "calculator_block_product_country_send"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "multiselect",
                          {
                            staticClass: "selectpicker",
                            attrs: {
                              multiple: false,
                              placeholder: _vm.get_translation_constant(
                                "calculator_block_product_choose_country_send"
                              ),
                              options: _vm.departure_countries,
                              label: "name",
                              selectLabel: "",
                              deselectLabel: "",
                              optionHeight: 48,
                              showPointer: true,
                            },
                            model: {
                              value: _vm.departure_country,
                              callback: function ($$v) {
                                _vm.departure_country = $$v
                              },
                              expression: "departure_country",
                            },
                          },
                          [void 0],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-4" }, [
                    _c(
                      "div",
                      { staticClass: "form__col" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.get_translation_constant(
                                "calculator_block_product_country_arrival"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "multiselect",
                          {
                            staticClass: "selectpicker",
                            attrs: {
                              multiple: false,
                              placeholder: _vm.get_translation_constant(
                                "calculator_block_product_choose_country_arrival"
                              ),
                              options: _vm.arrival_countries,
                              label: "name",
                              selectLabel: "",
                              deselectLabel: "",
                              optionHeight: 48,
                              showPointer: true,
                            },
                            model: {
                              value: _vm.arrival_country,
                              callback: function ($$v) {
                                _vm.arrival_country = $$v
                              },
                              expression: "arrival_country",
                            },
                          },
                          [void 0],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col-12 col-lg-6" }, [
                  _c("p", { staticClass: "h_text font_semibold" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.get_translation_constant(
                            "calculator_block_product_package_weight"
                          )
                        ) +
                        ":\n                            " +
                        _vm._s(_vm.packageWeight) +
                        " ( " +
                        _vm._s(
                          _vm.get_translation_constant(
                            "calculator_block_volume_weight"
                          )
                        ) +
                        "\n                            " +
                        _vm._s(_vm.volumeWeight) +
                        ".)"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-lg-6 total__price d-lg-flex align-items-center justify-content-end",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.get_translation_constant(
                            "calculator_block_delivery_price"
                          )
                        ) +
                        " "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.calculatedPrice))]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-md-flex justify-content-end" }, [
      _c(
        "a",
        {
          staticClass: "btn btn__medium btn__blue_dark d-block",
          attrs: { href: _vm.redirectsurl },
        },
        [
          _vm._v(
            _vm._s(_vm.get_translation_constant("calculator_block_btn_submit"))
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-auto px-xl-0 text-right mt-3 mt-xl-0" },
      [
        _c("strong", { staticClass: "color__gray_1" }, [
          _vm._v("/6000\n                                = "),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }